import React from "react";
import cn from "classnames";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { Button } from "../../common/button";
import styles from "./avatar.module.css";

export const Avatar = ({ togglePopup, isOpen = false }) => {
  const { t } = useTranslation();
  const {
    profile: { initials, cover_image_url: profileImage }
  } = useSelector(state => state.account);

  return (
    <Button
      onClick={() => togglePopup("links")}
      className={cn("button--clear", styles.buttonAvatar)}
      aria-label={t("dashboard_header_account_menu")}
      aria-expanded={isOpen}
    >
      <span className={styles.avatar}>
        {profileImage ? <img className={styles.avatar} src={profileImage} alt="" /> : <span>{initials}</span>}
      </span>
      <span className={styles.caret} aria-hidden="true" />
    </Button>
  );
};
